import clsx from 'clsx'
import { Button, Icon, TailwindModal, Typography } from 'components'
import { GenericModalProps, TypographyTypes } from 'interfaces'
import React from 'react'

export const ModalConfirm: React.FC<GenericModalProps<unknown>> = ({
	open,
	setOpen,
	onClickConfirm,
	title,
	descripcion,
	icon,
	buttonLabel = 'Continue',
	buttonLabelCancel = 'Cancel',
	hasCancel = false,
	handleCancel,
	flexButton = 'row',
	classNameButton,
	childrenModalConfirmation,
	widhtModal = 'w-[360px]',
	reverseButton,
	showCloseButton = true
}) => {
	return (
		<TailwindModal
			open={open}
			setOpen={setOpen}
			showCloseButton={showCloseButton}
			className={clsx('min-h-[168px] p-4 rounded-[16px]', widhtModal)}
		>
			<div className="flex flex-col gap-4 w-full">
				<div className="flex flex-col gap-3 w-full items-center">
					<div className="w-[30px] h-[30px]">
						{!!icon && (
							<Icon src={icon} fillPath className="text-blue-primary" />
						)}
					</div>
					{!!title && (
						<Typography
							title={title}
							fontLeading="15/18"
							type={TypographyTypes.h3}
							className="text-blue-primary text-center"
						/>
					)}
					{!!descripcion && (
						<Typography
							title={descripcion}
							fontLeading="15/18"
							type={TypographyTypes.h3}
							className="!font-normal text-black-1 text-center"
						/>
					)}
					{childrenModalConfirmation}
				</div>
				<div
					className={clsx(
						'flex  justify-center items-center gap-4 w-full',
						{
							'flex-col gap-3': flexButton === 'col'
						},
						{
							'flex-row-reverse gap-3': flexButton === 'row' && reverseButton
						}
					)}
				>
					{hasCancel && flexButton === 'row' && (
						<Button
							label={buttonLabelCancel}
							onClick={handleCancel}
							className={`!min-w-[unset] ${classNameButton ?? '!py-3 !px-9'}`}
							color={reverseButton ? 'Primary' : 'Gray2'}
							buttonTextClassName={clsx(
								reverseButton !== undefined
									? !reverseButton
										? 'text-blue-primary'
										: 'text-white'
									: ''
							)}
						/>
					)}
					<Button
						label={buttonLabel}
						onClick={onClickConfirm}
						className={`!min-w-[unset] ${classNameButton ?? '!py-3 !px-9'} `}
						color={!reverseButton ? 'Primary' : 'Gray2'}
						buttonTextClassName={clsx(
							reverseButton !== undefined
								? reverseButton
									? 'text-blue-primary'
									: 'text-white'
								: ''
						)}
					/>

					{hasCancel && flexButton === 'col' && (
						<Button
							label={buttonLabelCancel}
							onClick={handleCancel}
							className={`!min-w-[unset] ${classNameButton ?? '!py-3 !px-9'}`}
							color="Gray2"
						/>
					)}
				</div>
			</div>
		</TailwindModal>
	)
}
